import { settingsApi } from '@/services/api';

export const state = {
  settings: null,
  loading: false,
  saving: false,
  error: null,
};

export const mutations = {
  SET_SETTINGS(state, settings) {
    state.settings = settings;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_SAVING(state, saving) {
    state.saving = saving;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  CLEAR_ERROR(state) {
    state.error = null;
  },
};

export const actions = {
  async fetchSettings({ commit }) {
    commit('SET_LOADING', true);
    commit('CLEAR_ERROR');
    try {
      const settings = await settingsApi.get();
      commit('SET_SETTINGS', settings);
      return settings;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.detail || 'Không thể tải cài đặt');
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateSettings({ commit }, data) {
    commit('SET_SAVING', true);
    commit('CLEAR_ERROR');
    try {
      const settings = await settingsApi.update(data);
      commit('SET_SETTINGS', settings);
      return settings;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.detail || 'Không thể lưu cài đặt');
      throw error;
    } finally {
      commit('SET_SAVING', false);
    }
  },

  async setTvLock({ commit, state }, locked) {
    commit('CLEAR_ERROR');
    try {
      const res = await settingsApi.setTvLock(locked);
      commit('SET_SETTINGS', { ...state.settings, tv_locked: res.tv_locked });
      return res.tv_locked;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.detail || 'Không thể khoá/mở màn hình TV');
      throw error;
    }
  },

  clearError({ commit }) {
    commit('CLEAR_ERROR');
  },
};
